import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Grid,
    Stack,
    Divider
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import map from "lodash/map";

import get from "lodash/get";
import InputText from "../../../components/form/InputText";
import AutoComplete from "../../../components/form/AutoComplete";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@mui/icons-material/Save';

import { postRoutePayment } from "../../../store/transactions/thunk/route/postPayment";

const Alert = ({
    __,
    open,
    close,
    selected,
    setSelected,
    reload,
    setError
}) => {
    const dispatch = useDispatch();
    const idCostRoute = Number(get(selected, "id"));
    const { id } = useParams();

    const current = selected
    const currentRoute = useSelector((state) => state.transactions.route.detail);
    const post = useSelector(state => state.transactions.route.postCost);
    const user = useSelector(state => state.auth.login.dataUser);
    const customerId = get(currentRoute, "data.customerId");
    const paymentClient = useSelector(state => state.transactions.paymentClient)

    const paymentOptions = map(get(paymentClient, "data.data", []), ({ id, codInvoices, description, price }) => ({
        value: id,
        label: `${codInvoices} - ${description} - $${price?.toFixed(2)}`,
    }));

    const onCloseModal = (r) => {
        setSelected({})
        close()
        if (r === "1") {
            reload()
        }
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { onCloseModal("1") }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    }, [post])

    const onSubmit = (values) => {
        const selectedPayment = get(paymentClient, "data.data", []).find(p => p.id === get(values, "paymentRoute"));
        const body = {
            idRoute: Number(id),
            customerId: customerId,
            id: Number(get(values, "paymentRoute")),
            quantity: Number(get(values, "quantity")),
            price: Number(get(selectedPayment, "price", 0)),
            comments: "",
        }
       dispatch(postRoutePayment(body))
    }

    const initialValues = {

        paymentRoute: "",
        quantity: "",
        comments: ""
    }

    return (
        <div>
            <Dialog onClose={close} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {__("labels.14")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                               // validationSchema={validatorTariff(__)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="route-cost-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <AutoComplete
                                                            formik={formik}
                                                            name="paymentRoute"
                                                            label={__(`formPayment.paymentRoute.label`)}
                                                            placeholder={__(`formPayment.paymentRoute.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false)}
                                                            options={paymentOptions}

                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="quantity"
                                                            label={__(`formPayment.quantity.label`)}
                                                            placeholder={__(`formPayment.quantity.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false)}
                                                            type="number"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton variant="contained" startIcon={<SaveIcon/>} color="secondary" type="submit" form="route-cost-form" loading={get(post, "isLoading")}>{__("action.save")}</LoadingButton>
                    <Button variant='outlined' color="secondary" onClick={onCloseModal} disabled={get(post, "isLoading")} >{__(`action.cancel`)}</Button>
                </Stack>
            </Dialog>
        </div >
    );
}

export default Alert